export const REFUND_NO = 0;
export const REFUND_YES = 1;	
export const redundFormat = val => {
    switch (val) {
        case REFUND_NO:
            return '未退款';
        case REFUND_YES:
            return '已退款';
    };
    return '';
};

export const refundStatusFormat = val => {
    switch (val) {
        case 0:
            return '申请中';
        case 1:
            return '已退款';
        case 2:
            return '退款失败';
        case 3:
            return '撤回申请';
    };
    return '';
};